<app-score-dashboard
    [title]="'Attendance Score'"
    [trendingTitle]="'My Score Trending'"
    [centerText]="'My Score'"
    [employeeId]="sectionUserId(PermissionType.MyScoreAttendance)"
    [daysLookBack]="daysLookBack"
    [containerClass]="containerClass"
    [palette]="palette"
    [noDataExclude]="attendanceTimeOffTypes"
    [showScore]="canView(PermissionType.MyScoreAttendance)"
    [showFinancials]="canView(PermissionType.MyScoreFinancialDetails)"
    [showTrending]="canView(PermissionType.MyScoreTrending)"
    [loadScoreData]="loadScoreData"
    [loadTrendingData]="loadTrendingData"
    [processScoreData]="processScoreData"
    [exportData]="exportData"
    (dateRangeChanged)="onDateRangeChanged($event)">

    <ng-container intermediate-content>
        @if (canView(PermissionType.MyScoreAttendance)) {
            @if (summary$ | async) {
                <app-summary-card [items]="summaryCards" class="mb-4"></app-summary-card>
            }
        }
    </ng-container>

    <ng-container bottom-content>
        @if (canView(PermissionType.MyScoreFinancialDetails)) {
            <div class="mb-4">
                <h6 class="text-muted text-uppercase mb-3">Financial Details</h6>

                @if (summary$ | async) {
                    <app-summary-card [items]="financialDetails"></app-summary-card>
                }
            </div>
        }
    </ng-container>
</app-score-dashboard>
